import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const ToolbarSplatMoveIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M9.63 8H8.62C8.27758 8 8 8.27758 8 8.62V9.63C8 9.97242 8.27758 10.25 8.62 10.25H9.63C9.97242 10.25 10.25 9.97242 10.25 9.63V8.62C10.25 8.27758 9.97242 8 9.63 8Z"
        fill={color}
      />
      <path
        d="M9.63 13.75H8.62C8.27758 13.75 8 14.0276 8 14.37V15.38C8 15.7224 8.27758 16 8.62 16H9.63C9.97242 16 10.25 15.7224 10.25 15.38V14.37C10.25 14.0276 9.97242 13.75 9.63 13.75Z"
        fill={color}
      />
      <path
        d="M15.38 13.75H14.37C14.0276 13.75 13.75 14.0276 13.75 14.37V15.38C13.75 15.7224 14.0276 16 14.37 16H15.38C15.7224 16 16 15.7224 16 15.38V14.37C16 14.0276 15.7224 13.75 15.38 13.75Z"
        fill={color}
      />
      <path
        d="M15.38 8H14.37C14.0276 8 13.75 8.27758 13.75 8.62V9.63C13.75 9.97242 14.0276 10.25 14.37 10.25H15.38C15.7224 10.25 16 9.97242 16 9.63V8.62C16 8.27758 15.7224 8 15.38 8Z"
        fill={color}
      />
      <path
        d="M12.51 10.88H11.5C11.1576 10.88 10.88 11.1576 10.88 11.5V12.51C10.88 12.8524 11.1576 13.13 11.5 13.13H12.51C12.8524 13.13 13.13 12.8524 13.13 12.51V11.5C13.13 11.1576 12.8524 10.88 12.51 10.88Z"
        fill={color}
      />
      <path
        d="M9.69998 3.36H11.37V5.83C11.37 6.18 11.65 6.45 11.99 6.45C12.33 6.45 12.61 6.17 12.61 5.83V3.36H14.28C14.59 3.36 14.77 2.99 14.56 2.75L12.47 0.219995C12.22 -0.0800049 11.77 -0.0800049 11.52 0.219995L9.40998 2.75C9.20998 2.99 9.37998 3.36 9.68998 3.36H9.69998Z"
        fill={color}
      />
      <path
        d="M14.3 20.64H12.63V18.17C12.63 17.83 12.35 17.55 12.01 17.55C11.67 17.55 11.39 17.83 11.39 18.17V20.64H9.72003C9.41003 20.64 9.23002 21.01 9.44002 21.25L11.55 23.78C11.8 24.08 12.25 24.08 12.5 23.78L14.61 21.25C14.81 21.01 14.64 20.64 14.33 20.64H14.3Z"
        fill={color}
      />
      <path
        d="M23.78 11.53L21.25 9.41999C21.01 9.21999 20.64 9.38999 20.64 9.69999V11.37H18.17C17.83 11.37 17.55 11.65 17.55 11.99C17.55 12.33 17.83 12.61 18.17 12.61H20.64V14.28C20.64 14.59 21.01 14.77 21.25 14.56L23.78 12.45C24.08 12.2 24.08 11.75 23.78 11.5V11.53Z"
        fill={color}
      />
      <path
        d="M5.83 11.38H3.36V9.71002C3.36 9.40002 2.99 9.22002 2.75 9.43002L0.219995 11.53C-0.0800049 11.78 -0.0800049 12.23 0.219995 12.48L2.75 14.59C2.99 14.79 3.36 14.62 3.36 14.31V12.64H5.83C6.18 12.64 6.45 12.36 6.45 12.02C6.45 11.68 6.17 11.4 5.83 11.4V11.38Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ToolbarSplatMoveIcon.displayName = 'ToolbarSplatMoveIcon';
